import React from 'react';
import PropType from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Select from 'components/forms/Select';
import { makeStyles } from '@material-ui/styles';
import { INCLUDE_EXCLUDE_STATUSES, OPPORTUNITY_STAGES } from 'constants/misc';


const useStyles = makeStyles(theme => ({
  accordionSubtitle: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '146%',
    letterSpacing: '-0.01em',
    color: theme.palette.primary.text,
  },
}));

const ExistingContactImportForm = ({
  handleSubmit,
}) => {
  const classes = useStyles();
  return (
    <form onSubmit={handleSubmit}>
      <div className={`${classes.accordionSubtitle} mb-2`}>
        Upload contacts based on the most recent inbox category
      </div>
      <div>
        <Field
          name="replyStatusField"
          component={propsCus => (
            <Select
              placeholder="Choose Categories"
              isMulti
              value={propsCus.input.value}
              onChange={propsCus.input.onChange}
              onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
              options={INCLUDE_EXCLUDE_STATUSES || []}
            />
        )}
        />
      </div>
      <div className={`${classes.accordionSubtitle} mb-2 mt-4`}>
        Upload contacts based on their current opportunity stage
      </div>
      <div>
        <Field
          name="opportunityStageField"
          component={propsCus => (
            <Select
              placeholder="Choose Stages"
              isMulti
              value={propsCus.input.value}
              onChange={propsCus.input.onChange}
              onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
              options={OPPORTUNITY_STAGES || []}
            />
        )}
        />
      </div>
    </form>
  );
};


ExistingContactImportForm.propTypes = {
  handleSubmit: PropType.func.isRequired,
};

export default compose(
  connect(() => ({
    initialValues: { replyStatusField: [], replyRadio: 'include', stageRadio: 'include' },
  })),
  reduxForm({
    form: 'ExistingContactImportForm',
  }),
)(ExistingContactImportForm);
